
// Constants

export const ROUTES = {
    HOME: '/home'
}